"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScaffoldRoutes = void 0;
exports.ScaffoldRoutes = {
    fetchUser: '/users/auth/user_details/',
    signOutUser: '/users/auth/logout/',
};
